<p-button
  severity="primary"
  icon="pi pi-chevron-right"
  iconPos="right"
  [label]="'chatMessages.smartSearch.openButton' | transloco"
  (click)="openSmartSearchModal()"
  [ngClass]="{ hidden: disabled() }"
  [disabled]="disabled()" />
